import * as React from "react";
import type { AppIconPreviewGalleryButtonProps } from "./AppIconPreviewGalleryButton.types";
import { renderAppIconPreviewGalleryButton } from "./renderAppIconPreviewGalleryButton";
import { useAppIconPreviewGalleryButton } from "./useAppIconPreviewGalleryButton";
import type { ForwardRefComponent } from "@fluentui/react-components";
import { useAppIconPreviewGalleryButtonStyles } from "./useAppIconPreviewGalleryButtonStyles.styles";

export const AppIconPreviewGalleryButton: ForwardRefComponent<AppIconPreviewGalleryButtonProps> =
  React.memo(
    React.forwardRef<HTMLButtonElement, AppIconPreviewGalleryButtonProps>(
      (props, ref) => {
        const state = useAppIconPreviewGalleryButton(props, ref);
        useAppIconPreviewGalleryButtonStyles(state);
        return renderAppIconPreviewGalleryButton(state);
      }
    )
  );
